import styled from "styled-components"
import {
  width,
  minWidth,
  maxWidth,
  space,
  flexDirection,
  alignItems,
  justifyContent,
  flex,
  color,
  textAlign,
  flexWrap,
  position,
} from "styled-system"

export default styled.div`
  display: flex;
  position: relative;
  ${width};
  ${maxWidth};
  ${space};
  ${flexDirection};
  ${justifyContent};
  ${alignItems};
  ${flex};
  ${color};
  ${flexWrap};
  ${textAlign};
  ${position};
  ${minWidth};
`



// WEBPACK FOOTER //
// ./src/lib/ui/ui-box/ui-box.component.ts